// Bootstrap: dựng cây lệnh (xem `lib/build-avatar-command-registry.ts`) rồi parse argv.
// Mỗi lệnh sống ở src/commands/<name>.ts dưới dạng hàm nhận Command và tự đăng ký.
import { printAvatarBanner } from "./lib/avatar-ascii-banner.js";
import { buildAvatarCommandRegistry } from "./lib/build-avatar-command-registry.js";
import {
  isNonInteractiveFatalError,
  reportNonInteractiveError,
} from "./lib/non-interactive-abort-error.js";
import { readCliVersion } from "./lib/read-cli-version-from-package-json.js";

const CLI_VERSION = readCliVersion();

// In banner khi user gọi `avatar -v` / `avatar --version`. Banner đã chứa
// version trong tagline nên ta short-circuit luôn, không để commander in thêm
// dòng "1.0.1" dư thừa.
//
// Chỉ bắt khi -v/--version là token ĐẦU TIÊN (không có subcommand). Dùng
// firstArg thay .includes() toàn argv — tránh nuốt nhầm flag của lệnh con.
// (Lưu ý: lệnh con KHÔNG được đặt tên option là `--version` vì commander coi đó
// là global version flag — vd `sync` dùng `--pack-version`, không phải `--version`.)
const firstArg = process.argv[2];
const isVersionCall = firstArg === "-v" || firstArg === "--version";
if (isVersionCall) {
  printAvatarBanner({ tagline: `v${CLI_VERSION} · AI harness CLI for NAL Vietnam` });
  process.exit(0);
}

const program = buildAvatarCommandRegistry();

program.parseAsync(process.argv).catch((err: unknown) => {
  // Điểm hỏi bị chặn ở chế độ non-interactive: in JSON 1 dòng ra stderr rồi thoát
  // ≠0. Bắt ở đây thay vì trong từng `.action()` để 63 điểm hỏi dùng chung một
  // đường thoát — thiếu một chỗ là lỗi lọt ra dạng stack trace, không parse được.
  if (isNonInteractiveFatalError(err)) {
    process.exit(reportNonInteractiveError(err));
  }
  // Top-level error sink. Individual commands should handle their own errors;
  // anything reaching here is unexpected.
  const msg = err instanceof Error ? err.message : String(err);
  process.stderr.write(`✗ Lỗi không xử lý được: ${msg}\n`);
  process.exit(1);
});
